<template>
    <section>
        <div class="component-box">
            <div class="flex justify-between items-center">
                <p class="font-semibold">
                    {{ $t('common.audience') }}
                </p>
                <el-button
                    type="primary"
                    size="medium"
                    :disabled="!selected_ads_account || !selected_ads_account.advertiser_id"
                    @click="createAd()"
                >
                    Tạo quảng cáo
                </el-button>
            </div>
        </div>

        <div class="component-box mt-[30px]">
            <div v-if="current_component === 'list'">
                <div class="flex">
                    <div class="flex-1">
                        <div v-loading="fetching_ads_accounts" class="flex flex-wrap gap-2">
                            <label-outside-input-select
                                :label="$t('common.advertiser_account')"
                            >
                                <el-select
                                    :value="selected_ads_account"
                                    value-key="advertiser_id"
                                    size="small"
                                    filterable
                                    :placeholder="
                            $t('input.placeholder.select_ads_account')
                        "
                                    class="w-[260px]"
                                    @change="handleChangeAdsAcc"
                                >
                                    <el-option-group
                                        :label="$t('common.advertiser_account')"
                                    >
                                        <el-option
                                            v-for="item in m__ads_accounts"
                                            :key="item.advertiser_id"
                                            :label="item.name"
                                            :value="item"
                                        >
                                            <div class="relative">
                                                <div
                                                    v-if="item.belong_to_atosa"
                                                    class="-right-4 bg-brand-atosa--light util-flex-center absolute bottom-0 h-5 px-1 text-white"
                                                >
                                        <span class="text-xxxs uppercase">
                                            atosa
                                        </span>
                                                </div>
                                                <div class="flex flex-col py-1">
                                        <span
                                            class="text-xs font-semibold leading-5"
                                        >
                                            {{ item.name }}
                                        </span>
                                                    <div
                                                        class="flex items-center space-x-1 leading-3"
                                                    >
                                                        <i class="el-icon-money"></i>

                                                        <span class="text-xs">
                                                {{
                                                                p__renderMoneyByCurrency(
                                                                    item.balance,
                                                                    item.currency
                                                                )
                                                            }}
                                            </span>
                                                    </div>
                                                    <span class="component-text-desc">
                                            #{{ item.advertiser_id }}
                                        </span>
                                                </div>
                                            </div>
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </label-outside-input-select>

                            <label-outside-input-select :label="$t('common.balance')">
                                <el-input
                                    size="small"
                                    :value="`${p__formatCurrency(
                            current_balance
                        )} ${currency}`"
                                    class="w-[140px]"
                                ></el-input>
                            </label-outside-input-select>
                        </div>
                    </div>
                    <div class="flex-2 text-right flex gap-[10px]">
                        <el-dropdown trigger="click">
                            <el-button type="primary" size="small">
                                Tạo đối tượng <i class="el-icon-arrow-down"></i>
                            </el-button>
                            <el-dropdown-menu
                                slot="dropdown"
                            >
                                <el-dropdown-item
                                    @click.native="show_dialog.create_audience = true; el_drawer_display_type = 'list'"
                                >
                                    Đối tượng tùy chỉnh
                                </el-dropdown-item>
                                <el-dropdown-item
                                    @click.native="show_dialog.create_audience = true; el_drawer_display_type = 'create'; el_drawer_audience_type = 'lookalike'"
                                >
                                    Đối tượng tương tự
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown trigger="click">
                            <el-button size="small">
                                Hành động <i class="el-icon-arrow-down"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="getAudiences()">Làm mới đối tượng</el-dropdown-item>
                                <el-dropdown-item
                                    :disabled="!canShareAudience()"
                                    @click.native="show_dialog.share_audience = true"
                                >
                                    Chia sẻ
                                </el-dropdown-item>
                                <el-dropdown-item
                                    :disabled="!canDeleteAudiences()"
                                    @click.native="confirmDeleteAudiences()"
                                >Xóa
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-input
                            v-model="audience_keyword"
                            size="small"
                            class="w-[250px]"
                            suffix-icon="el-icon-search"
                            clearable
                            placeholder="ID hoặc từ khóa về đối tượng"
                        ></el-input>
                    </div>
                </div>
                <div class="mt-[40px]">
                    <el-table v-loading="loading.get_data" :data="c__audience_list" class="cancel-flex-end">
                        <el-table-column label="#" width="50px" fixed="left">
                            <template slot="header" slot-scope="scope">
                                <el-checkbox
                                    :value="tableCheckedAll"
                                    :indeterminate="tableIndeterminate"
                                    @change="toggleCheckboxAll"
                                ></el-checkbox>
                            </template>
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.checked"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('common.name')" width="330px" fixed="left">
                            <template slot-scope="scope">
                                <!--                            <pre>{{ scope.row }}</pre>-->
                                <div class="flex flex-col gap-[5px] audience-hover">
                                    <div class="flex items-center justify-between pr-[10px]">
                                    <span
                                        class="text-[14px] cursor-pointer hover:text-[#006764]"
                                        @click="selected_audience = scope.row; current_component = 'detail';"
                                    >
                                        {{ scope.row.name }}
                                    </span>

                                        <div>
                                            <el-popover
                                                :ref="`popover-name-` + scope.$index"
                                                placement="right"
                                                width="400"
                                                trigger="click"
                                                @click.native="edit_name = scope.row.name"
                                            >
                                                <div class="flex flex-col gap-[5px] p-[10px]">
                                                    <div>
                                                        <strong class="text-[14px]">
                                                            Tên đối tượng
                                                        </strong>
                                                    </div>
                                                    <div class="flex">
                                                        <el-input
                                                            v-model="edit_name"
                                                            size="small"
                                                            class="flex-1"
                                                        ></el-input>
                                                        <el-button
                                                            size="small"
                                                            icon="el-icon-close"
                                                            class="ml-[10px]"
                                                            @click="$refs['popover-name-' + scope.$index].doClose()"
                                                        ></el-button>
                                                        <el-button
                                                            type="primary"
                                                            size="small"
                                                            icon="el-icon-check"
                                                            :loading="loading.edit_name"
                                                            @click="confirmEditName(scope.row, scope.$index)"
                                                        ></el-button>
                                                    </div>
                                                </div>
                                                <i slot="reference" class="el-icon-edit text-[14px] cursor-pointer"></i>
                                            </el-popover>
                                        </div>
                                    </div>
                                    <div
                                        v-if="scope.row.audience_type === 'Lookalike Audience'"
                                        class="hidden audience-option"
                                    >
                                        <div>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-refresh"
                                                :disabled="!scope.row.cover_num"
                                            >
                                                Làm mới đối tượng
                                            </el-button>
                                        </div>
                                        <div>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-thumb"
                                                :disabled="!scope.row.cover_num"
                                                @click="showApplyAudienceDialog(scope.row)"
                                            >
                                                Áp dụng
                                            </el-button>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-delete"
                                                @click="confirmDeleteAudiences(scope.row)"
                                            >
                                                Xóa
                                            </el-button>
                                        </div>
                                    </div>
                                    <div v-else class="hidden audience-option">
                                        <div>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-plus"
                                                :disabled="!canCreateLookalikeFromAudience(scope.row)"
                                                @click="createLookalikeFromAudience(scope.row)"
                                            >
                                                Tạo đối tượng tương tự
                                            </el-button>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-data-line"
                                                :disabled="true"
                                            >
                                                Nâng cao đối tượng
                                            </el-button>
                                        </div>
                                        <div>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-thumb"
                                                :disabled="!scope.row.cover_num"
                                                @click="showApplyAudienceDialog(scope.row)"
                                            >
                                                Áp dụng
                                            </el-button>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-rank"
                                                @click="confirmEnableREACHFREQUENCY(scope.row)"
                                            >
                                                Phạm vi tiếp cận và tần xuất
                                            </el-button>
                                            <el-button
                                                type="text"
                                                size="mini"
                                                icon="el-icon-delete"
                                                @click="confirmDeleteAudiences(scope.row)"
                                            >
                                                Xóa
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('common.type')">
                            <template slot-scope="scope">
                                <div class="flex flex-col gap-[2px]">
                                    <span class="text-[14px]">{{ mapAudienceType(scope.row) }}</span>
                                    <span class="text-[13px] text-[#999]">{{ mapAudienceEnum(scope.row) }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('common.size')" prop="cover_num" :sortable="true">
                            <template slot-scope="scope">
                                {{ p__formatCurrency(scope.row.cover_num) }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('common.available')" width="330px">
                            <template slot-scope="scope">
                                <template v-if="scope.row.is_valid">
                                    <div class="flex items-center">
                                        <div class="active-circle"></div>
                                        Sẵn có
                                    </div>
                                </template>
                                Cập nhật lần gần nhất: {{ p__formatDate(scope.row.create_time) }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="'ID ' + $t('common.audience')">
                            <template slot-scope="scope">
                                {{ scope.row.audience_id }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div v-if="current_component === 'detail'">
                <el-button size="mini" @click="current_component = 'list'; getAudiences()">
                    <i class="el-icon-arrow-left"></i>
                    Quay lại
                </el-button>

                <AudienceDetail :ads_account="selected_ads_account" :audience="selected_audience">

                </AudienceDetail>
            </div>
        </div>

        <el-drawer
            title="Tạo đối tượng"
            size="1100px"
            :visible.sync="show_dialog.create_audience"
        >
            <div>
                <div v-if="el_drawer_display_type === 'list'" class="p-[25px]">
                    <div class="text-[14px]">
                        <p>Chọn loại đối tượng</p>
                    </div>
                    <div class="mt-[30px] flex flex-wrap gap-[25px]">
                        <div
                            v-for="item in audience_type_list"
                            :key="item.name"
                            class="px-[31px] py-[24px] bg-[#f8f8f9] flex gap-[25px] cursor-pointer"
                            style="flex: 1 1 calc(50% - 30px)"
                            @click="selectAudienceType(item.type)"
                        >
                            <div class="w-[29px]">
                                <img
                                    :src="item.image"
                                    alt=""
                                    class="object-cover"
                                >
                            </div>
                            <div class="flex-1 flex flex-col">
                                <span class="text-[16px]">{{ item.name }}</span>
                                <span class="text-[13px]">{{ item.description }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="el_drawer_display_type === 'create'"
                    class="relative w-[100%] px-[25px] overflow-hidden"
                    style="height: calc(100vh - 75px)"
                >
                    <div class="overflow-y-scroll" style="height: calc(100vh - (75px + 80px))">
                        <div v-if="el_drawer_audience_type === 'create_by_file'">
                            <CreateAudienceByFile
                                :ads_account="selected_ads_account"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'engagement'">
                            <CreateEngagementAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'app_activity'">
                            <CreateAppActivityAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'website_traffic'">
                            <CreateWebsiteTrafficAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'lead_gen'">
                            <CreateLeadGenAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'tiktok_shop'">
                            <CreateTiktokShopAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'offline_activity'">
                            <CreateOfflineActivityAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                        <div v-if="el_drawer_audience_type === 'lookalike'">
                            <CreateLookalikeAudience
                                :ads_account="selected_ads_account"
                                :emit_create="emit_create_id"
                                :create_loading.sync="loading.create_audience"
                                :audience_list="audience_list"
                                :from_source_id="source_audience_id"
                                @reload_audience="getAudiences()"
                            />
                        </div>
                    </div>
                    <div class="absolute bottom-0 right-0 w-[100%] h-[80px] px-[25px] flex items-center bg-[#fff]">
                        <div class="flex justify-between items-center] w-[100%]">
                            <div>
                                <el-button size="medium" @click="el_drawer_display_type = 'list'">Quay lại</el-button>
                            </div>
                            <div class="text-right">
                                <el-button size="medium" @click="show_dialog.create_audience = false">Hủy</el-button>
                                <el-button
                                    type="primary"
                                    size="medium"
                                    :loading="loading.create_audience"
                                    @click="generateEmitCreateId()"
                                >Xác nhận
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>

        <el-dialog
            width="600px"
            :close-on-click-modal="false"
            :visible.sync="show_dialog.share_audience"
            custom-class="no-body"
        >
            <div slot="title">
                <div>
                    <strong class="text-[14px]">Chia sẻ đối tượng</strong>
                </div>
            </div>
            <div slot="default">
                <div class="bg-[#e8fbf9] border-[#e8fbf9] p-[10px] text-[13px]">
                    <i class="el-icon-question"></i>
                    Người nhận sẽ không thể chỉnh sửa, chia sẻ hay tạo đối tượng tương tự dựa trên đối tượng của
                    bạn.
                </div>

                <div class="mt-[30px] flex flex-col gap-[10px]">
                    <strong class="text-[14px]">Chọn tài khoản quảng cáo</strong>
                    <el-select
                        v-model="shared_advertiser_ids"
                        size="small"
                        value=""
                        multiple
                        collapse-tags
                        filterable
                        clearable
                    >
                        <el-option
                            v-for="item in m__ads_accounts"
                            :key="item.advertiser_id"
                            :value="item.advertiser_id"
                            :label="item.advertiser_id"
                        >
                            <span>{{ item.name }}</span>
                            <br>
                            <span>ID: {{ item.advertiser_id }}</span>
                        </el-option>
                    </el-select>
                </div>

                <div class="mt-[30px] text-right">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-check"
                        :loading="loading.share_audience"
                        @click="confirmShareAudiences()"
                    >Xác nhận
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            width="900px"
            :close-on-click-modal="false"
            :visible.sync="show_dialog.apply_audience"
            custom-class="no-body"
        >
            <div slot="title">
                <div>
                    <strong class="text-[16px]">Áp dụng cho Nhóm quảng cáo</strong>
                </div>
            </div>
            <div slot="default">
                <div class="flex flex-col gap-[8px]">
                    <strong class="text-[14px]">Chế độ sử dụng</strong>

                    <el-radio-group v-model="apply_audience.usage_mode" size="medium">
                        <el-radio-button label="Include">Bao gồm</el-radio-button>
                        <el-radio-button label="Exclude">Loại trừ</el-radio-button>
                    </el-radio-group>
                </div>

                <div class="flex flex-col mt-[40px] gap-[8px]">
                    <strong class="text-[14px]">Chọn Nhóm quảng cáo</strong>

                    <div class="flex gap-[10px]">
                        <div class="w-[33%]">
                            <div
                                v-loading="loading.get_campaigns"
                                class="border border-solid border-[#d3d4d5] rounded-[4px]"
                            >
                                <div
                                    class="h-[40px] border-b border-b-[#d3d4d5] bg-[#f2f3f3] flex items-center px-[10px]"
                                >
                                    <strong>
                                        Chiến dịch có sẵn
                                    </strong>
                                </div>
                                <div class="h-[200px] flex flex-col overflow-y-scroll">
                                    <div class="py-[15px] px-[10px]">
                                        <el-input
                                            v-model="campaign_keyword"
                                            size="mini"
                                            prefix-icon="el-icon-search"
                                            placeholder="Nhập ID hoặc tên chiến dịch"
                                        ></el-input>
                                    </div>
                                    <div
                                        v-for="campaign in c__campaign_list"
                                        :key="campaign.campaign_id"
                                        class="flex items-center cursor-pointer py-[6px] px-[10px] hover:bg-[#f2f3f3]"
                                        @click="callGetAdGroups(campaign.campaign_id)"
                                    >
                                        <div class="flex-1 pr-[15px] truncate">
                                            {{ campaign.campaign_name }}
                                        </div>
                                        <div class="w-[15px]">
                                            <i class="el-icon-arrow-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-[33%]">
                            <div
                                v-loading="loading.get_adgroups"
                                class="border border-solid border-[#d3d4d5] rounded-[4px]"
                            >
                                <div
                                    class="h-[40px] border-b border-b-[#d3d4d5] bg-[#f2f3f3] flex items-center px-[10px]"
                                >
                                    <strong>
                                        Nhóm quảng cáo có sẵn
                                    </strong>
                                </div>
                                <div class="h-[200px] flex flex-col overflow-y-scroll">
                                    <div class="py-[15px] px-[10px]">
                                        <el-input
                                            v-model="adgroup_keyword"
                                            size="mini"
                                            prefix-icon="el-icon-search"
                                            placeholder="Nhập ID hoặc tên nhóm quảng cáo"
                                        ></el-input>
                                    </div>
                                    <div
                                        v-for="adgroup in c__adgroup_list"
                                        :key="adgroup.adgroup_id"
                                        class="flex items-center cursor-pointer py-[6px] px-[10px] hover:bg-[#f2f3f3]"
                                        @click="addAdGroupToSelectedList(adgroup)"
                                    >
                                        <div class="flex-1 pr-[15px] truncate">
                                            {{ adgroup.adgroup_name }}
                                        </div>
                                        <div class="w-[15px]">
                                            <i class="el-icon-arrow-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-[33%] pl-[20px]">
                            <div class="border border-solid border-[#d3d4d5] rounded-[4px]">
                                <div
                                    class="h-[40px] border-b border-b-[#d3d4d5] bg-[#f2f3f3] flex items-center justify-between px-[10px]"
                                >
                                    <strong>
                                        Đã chọn {{ selected_adgroup_list.length }} mục
                                    </strong>

                                    <el-button type="text" size="mini">Xóa</el-button>
                                </div>
                                <div class="h-[200px] flex flex-col overflow-y-scroll">
                                    <div
                                        v-for="adgroup in selected_adgroup_list"
                                        :key="adgroup.adgroup_id"
                                        class="flex items-center cursor-pointer py-[6px] px-[10px]"
                                    >
                                        <div class="flex-1 pr-[15px] truncate">
                                            {{ adgroup.adgroup_name }}
                                        </div>
                                        <div
                                            class="w-[15px] cursor-pointer"
                                            @click="removeAdGroupFromSelectedList(adgroup)"
                                        >
                                            <i class="el-icon-close"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-[40px] text-right">
                    <el-button size="medium" @click="show_dialog.apply_audience = false">Hủy</el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        :loading="loading.apply_to_adgroups"
                        @click="confirmApplyToAdGroups()"
                    >Xác nhận
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import uuid from 'uuid'
import { defineComponent } from 'vue'
import FilterDatePicker from '@/views/campaign/campaign-wrapper/filter-date-picker/index.vue'
import FilterWrapper from '@/views/campaign/campaign-wrapper/filter/index.vue'
import selectedTiktokBusinessMixin from '@/plugins/mixins/selected-tiktok-business'
import {
    applyToAdGroups,
    deleteAudiences,
    getAllAudiences,
    shareAudiences,
    updateAudience
} from '@/services/atosa-tiktok-ads/audience'
import CreateAudienceByFile from './component/create_by_file.vue'
import CreateEngagementAudience from './component/create_engagement.vue'
import CreateAppActivityAudience from './component/create_app_activity.vue'
import CreateWebsiteTrafficAudience from './component/create_website_traffic.vue'
import CreateLeadGenAudience from './component/create_lead_gen.vue'
import CreateTiktokShopAudience from './component/create_tiktok_shop.vue'
import CreateOfflineActivityAudience from './component/create_offline_activity.vue'
import CreateLookalikeAudience from './component/create_lookalike.vue'
import AudienceDetail from './component/detail.vue'
import { getCampaigns } from '@/services/atosa-tiktok-ads/campaign'
import { getAdGroups } from '@/services/atosa-tiktok-ads/adgroup'
import { removeUnicode } from '@/plugins/prototypes/function'

export default defineComponent({
    mixins: [selectedTiktokBusinessMixin],

    components: {
        FilterWrapper,
        FilterDatePicker,
        CreateAudienceByFile,
        CreateEngagementAudience,
        CreateAppActivityAudience,
        CreateWebsiteTrafficAudience,
        CreateLeadGenAudience,
        CreateTiktokShopAudience,
        CreateOfflineActivityAudience,
        CreateLookalikeAudience,
        AudienceDetail
    },

    data() {
        return {
            selected_ads_account: null,
            fetching_ads_accounts: false,
            audience_list: [],
            loading: {
                get_data: false,
                create_audience: false,
                share_audience: false,
                get_campaigns: false,
                get_adgroups: false,
                apply_to_adgroups: false,
                edit_name: false
            },
            show_dialog: {
                create_audience: false,
                share_audience: false,
                apply_audience: false
            },
            audience_type_list: [
                {
                    name: 'Tệp khách hàng',
                    description: 'Tải lên tệp khách hàng để đối chiếu khách hàng của bạn với những người trên nền tảng của chúng tôi. Các kết quả trùng khớp sẽ được dùng để tạo đối tượng.',
                    image: 'data:image/svg+xml;base64,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',
                    type: 'create_by_file'
                },
                {
                    name: 'Sự tương tác',
                    description: 'Tạo danh sách những người đã xem, nhấp chuột hoặc tương tác với nội dung của bạn.',
                    image: 'data:image/svg+xml;base64,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',
                    type: 'engagement'
                },
                {
                    name: 'Hoạt động trong ứng dụng',
                    description: 'Tạo danh sách những người đã tải xuống ứng dụng của bạn hoặc thực hiện các hành động cụ thể, chẳng hạn như mua hàng.',
                    image: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjlweCIgaGVpZ2h0PSIyOXB4IiB2aWV3Qm94PSIwIDAgMjkgMjkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYxICg4OTU4MSkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R3JvdXAgMTI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iRE1QIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5Yib5bu66Ieq5a6a5LmJ5Y+X5LyXIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzU5LjAwMDAwMCwgLTQyMC4wMDAwMDApIiBzdHJva2U9IiMxMjE0MTUiPgogICAgICAgICAgICA8ZyBpZD0i5by556qXIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0xMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU5LjAwMDAwMCwgNDIwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNEOEQ4RDgiIHg9IjguNSIgeT0iMTIuNSIgd2lkdGg9IjEiIGhlaWdodD0iNSIgcng9IjAuNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weS0yIiBmaWxsPSIjRDhEOEQ4IiB4PSIxOS41IiB5PSIxMi41IiB3aWR0aD0iMSIgaGVpZ2h0PSI1IiByeD0iMC41Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0Q4RDhEOCIgeD0iMC41IiB5PSIxNC41IiB3aWR0aD0iMjgiIGhlaWdodD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIHN0cm9rZS13aWR0aD0iMiIgeD0iMSIgeT0iNiIgd2lkdGg9IjI3IiBoZWlnaHQ9IjIyIiByeD0iMiI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weSIgc3Ryb2tlLXdpZHRoPSIyIiB4PSI5IiB5PSIxIiB3aWR0aD0iMTEiIGhlaWdodD0iNSIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
                    type: 'app_activity'
                },
                {
                    name: 'Lưu lượng truy cập trang web',
                    description: 'Dùng TikTok Pixel để tạo danh sách những người đã truy cập trang web của bạn hoặc thực hiện các hành động cụ thể trên trang.',
                    image: 'data:image/svg+xml;base64,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',
                    type: 'website_traffic'
                },
                {
                    name: 'Tạo khách hàng tiềm năng',
                    description: 'Tạo danh sách những người đã xem hoặc gửi biểu mẫu tức thời trong một quảng cáo tạo khách hàng tiềm năng.',
                    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNyA4QzM4LjY1NjkgOCA0MCA5LjM0MzE1IDQwIDExQzQwIDEyLjY1NjkgMzguNjU2OSAxNCAzNyAxNEMzNS4zNDMxIDE0IDM0IDEyLjY1NjkgMzQgMTFDMzQgOS4zNDMxNSAzNS4zNDMxIDggMzcgOFpNMzkgMTcuNzEwMUM0MS44OTE1IDE2Ljg0OTYgNDQgMTQuMTcxIDQ0IDExQzQ0IDcuMTM0MDEgNDAuODY2IDQgMzcgNEMzMy4xMzQgNCAzMCA3LjEzNDAxIDMwIDExQzMwIDE0LjE3MSAzMi4xMDg1IDE2Ljg0OTYgMzUgMTcuNzEwMVYzNS41MDQyQzM1IDM3Ljk4NzEgMzIuOTg3MSA0MCAzMC41MDQyIDQwQzI4LjAyMTIgNDAgMjYuMDA4MyAzNy45ODcxIDI2LjAwODMgMzUuNTA0MlYxMi41MDQyQzI2LjAwODMgNy44MDc0NSAyMi4yMDA5IDQgMTcuNTA0MiA0QzEyLjgwNzQgNCA5IDcuODA3NDQgOSAxMi41MDQyVjMwLjI4OTlDNi4xMDg1MSAzMS4xNTA0IDQgMzMuODI5IDQgMzdDNCA0MC44NjYgNy4xMzQwMSA0NCAxMSA0NEMxNC44NjYgNDQgMTggNDAuODY2IDE4IDM3QzE4IDMzLjgyOSAxNS44OTE1IDMxLjE1MDQgMTMgMzAuMjg5OVYxMi41MDQyQzEzIDEwLjAxNjYgMTUuMDE2NiA4IDE3LjUwNDIgOEMxOS45OTE3IDggMjIuMDA4MyAxMC4wMTY2IDIyLjAwODMgMTIuNTA0MlYzNS41MDQyQzIyLjAwODMgNDAuMTk2MyAyNS44MTIgNDQgMzAuNTA0MiA0NEMzNS4xOTYzIDQ0IDM5IDQwLjE5NjMgMzkgMzUuNTA0MlYxNy43MTAxWk0xMSAzNEMxMi42NTY5IDM0IDE0IDM1LjM0MzEgMTQgMzdDMTQgMzguNjU2OSAxMi42NTY5IDQwIDExIDQwQzkuMzQzMTUgNDAgOCAzOC42NTY5IDggMzdDOCAzNS4zNDMxIDkuMzQzMTUgMzQgMTEgMzRaIiBmaWxsPSIjMTIxNDE1Ii8+Cjwvc3ZnPgo=',
                    type: 'lead_gen'
                },
                {
                    name: 'Business Account',
                    description: 'Tạo danh sách những người đã theo dõi hoặc tương tác với Business Account của bạn trên TikTok.',
                    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjAxIi8+CjxwYXRoIGQ9Ik0xMS44IDExLjhDMTQuNTA2MiAxMS44IDE2LjcgOS42MDYyIDE2LjcgNi45QzE2LjcgNC4xOTM4IDE0LjUwNjIgMiAxMS44IDJDOS4wOTM4MyAyIDYuOTAwMDIgNC4xOTM4IDYuOTAwMDIgNi45QzYuOTAwMDIgOS42MDYyIDkuMDkzODMgMTEuOCAxMS44IDExLjhaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjMTIxNDE1IiBzdHJva2Utd2lkdGg9IjIuMjQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIgMjcuMkMyIDI2LjU3NzggMiAyNS42NDQ1IDIgMjQuNEMyIDIwLjUzNCA1LjEzNDAxIDE3LjQgOSAxNy40SDE0LjZDMTguNDY2IDE3LjQgMjEuNiAyMC41MzQgMjEuNiAyNC40QzIxLjYgMjUuNjQ0NSAyMS42IDI2LjU3NzggMjEuNiAyNy4yIiBzdHJva2U9IiMxMjE0MTUiIHN0cm9rZS13aWR0aD0iMi4yNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMS43MTMzIDEwLjg0MDNDMjIuOTE4NiA5Ljk0NzY0IDIzLjcwMDEgOC41MTUwNSAyMy43MDAxIDYuODk5OTRDMjMuNzAwMSA1LjI4NDg0IDIyLjkxODYgMy44NTIyNCAyMS43MTMzIDIuOTU5NTkiIHN0cm9rZT0iIzEyMTQxNSIgc3Ryb2tlLXdpZHRoPSIyLjI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI1LjM0OTIgMTcuODA0QzI1LjczNjEgMTcuOTQxNyAyNi4xMDczIDE4LjExMjYgMjYuNDU5NCAxOC4zMTMxQzI2Ljg0MTcgMTguNTMwOSAyNy4yMDE2IDE4Ljc4MzcgMjcuNTM0NiAxOS4wNjcxQzI5LjA0MzEgMjAuMzUxMSAzMCAyMi4yNjM4IDMwIDI0LjRDMzAgMjUuNjQ0NSAzMCAyNi41Nzc4IDMwIDI3LjIiIHN0cm9rZT0iIzEyMTQxNSIgc3Ryb2tlLXdpZHRoPSIyLjI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==',
                    type: 'business_account'
                },
                {
                    name: 'Hoạt động trong cửa hàng',
                    description: 'Xây dựng đối tượng từ những người thực hiện một số hành động nhất định trong TikTok Shop.',
                    image: 'data:image/svg+xml;base64,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',
                    type: 'tiktok_shop'
                },
                {
                    name: 'Hoạt động ngoại tuyến',
                    description: 'Tạo danh sách những người đã tương tác với hoạt động sự kiện ngoại tuyến của bạn.',
                    image: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxjaXJjbGUgY3g9IjIwLjUiIGN5PSI0MS41IiByPSIzLjUiIGZpbGw9IiMxMjE0MTUiLz48Y2lyY2xlIGN4PSIzNy41IiBjeT0iNDEuNSIgcj0iMy41IiBmaWxsPSIjMTIxNDE1Ii8+PHBhdGggZD0iTTUgNkwxNCAxMkwxOSAzNEgzOUw0NCAxN0gyNSIgc3Ryb2tlPSIjMTIxNDE1IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJidXR0IiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+PHBhdGggZD0iTTI1IDI2TDMyLjI3MjcgMjZMNDEgMjYiIHN0cm9rZT0iIzEyMTQxNSIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0iYnV0dCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPjwvc3ZnPgo=',
                    type: 'offline_activity'
                }
            ],
            current_component: 'list',
            el_drawer_display_type: 'list',
            el_drawer_audience_type: null,
            emit_create_id: null,
            shared_advertiser_ids: [],
            source_audience_id: null,
            selected_audience: null,
            tiktok_account_id: null,
            campaign_list: [],
            adgroup_list: [],
            selected_adgroup_list: [],
            apply_audience: {
                action_mode: 'Apply',
                usage_mode: 'Include'
            },
            audience_keyword: '',
            campaign_keyword: '',
            adgroup_keyword: '',

            edit_name: ''
        }
    },

    async mounted() {
        this.tiktok_account_id = this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id
        await this.m__fetchAdsAccountsByTiktokBusiness()
        if (this.m__ads_accounts.length) this.selected_ads_account = this.m__ads_accounts[0]

        // todo: test
        const find = this.m__ads_accounts.find(i => i.advertiser_id.toString() === '7414367497031680017')
        if (find) this.selected_ads_account = find
    },

    watch: {
        m__selected_tiktok_business() {
            this.m__fetchAdsAccountsByTiktokBusiness()
                .then(() => {
                    if (this.m__ads_accounts.length) this.selected_ads_account = this.m__ads_accounts[0]

                    // todo: test
                    const find = this.m__ads_accounts.find(i => i.advertiser_id.toString() === '7414367497031680017')
                    if (find) this.selected_ads_account = find
                })
        },

        selected_ads_account() {
            this.getAudiences()
        }
    },

    computed: {
        current_balance() {
            if (this.selected_ads_account) {
                return this.selected_ads_account.balance
            }

            return 0
        },

        currency() {
            if (this.selected_ads_account) {
                return this.selected_ads_account.currency
            }

            return this.p__default_currency_app
        },

        c__audience_list() {
            const words = removeUnicode(this.audience_keyword)
            return this.audience_list.filter(i => removeUnicode(`${i.audience_id} ${i.name}`).includes(words))
        },

        tableCheckedAll() {
            const checked_length = this.c__audience_list.filter(i => i.checked).length
            return checked_length ? checked_length === this.c__audience_list.length : false
        },

        tableIndeterminate() {
            const checked_length = this.c__audience_list.filter(i => i.checked).length
            return checked_length ? checked_length !== this.c__audience_list.length : false
        },

        c__campaign_list() {
            const words = removeUnicode(this.campaign_keyword)
            return this.campaign_list.filter(i => removeUnicode(`${i.campaign_id} ${i.campaign_name}`).includes(words))
        },

        c__adgroup_list() {
            const words = removeUnicode(this.adgroup_keyword)
            return this.adgroup_list.filter(i => removeUnicode(`${i.adgroup_id} ${i.adgroup_name}`).includes(words))
        }
    },

    methods: {
        async confirmEditName(audience, row_index) {
            if (!this.edit_name) return

            this.loading.edit_name = true
            try {
                const form = {
                    advertiser_id: this.selected_ads_account.advertiser_id,
                    custom_audience_id: audience.audience_id
                }
                form.custom_audience_name = this.edit_name

                const response = await updateAudience(this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id, form)
                const {
                    code,
                    message
                } = response.data
                if (code === 0) {
                    this.$notify({
                        title: 'Thông báo',
                        message: 'Cập nhật đối tượng thành công',
                        type: 'success'
                    })
                    await this.getAudiences()
                    this.$refs['popover-name-' + row_index].doClose()
                } else {
                    this.$notify({
                        title: 'Lỗi',
                        message: 'Đã có lỗi xảy ra khi cập nhật đối tượng. Mã lỗi: ' + message,
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.error(e)
            }
            this.loading.edit_name = false
        },

        createAd() {
            this.$router.push('/ads-manager/campaign/create?advertiser_id=' + this.selected_ads_account.advertiser_id)
        },

        async confirmApplyToAdGroups() {
            try {
                await this.$confirm('Bạn có muốn áp dụng đối tượng này cho những nhóm quảng cáo đã chọn không?', 'Xác nhận Áp dụng nhóm quảng cáo')
            } catch (e) {
                return
            }

            this.loading.apply_to_adgroups = true
            try {
                const form = {
                    advertiser_id: this.selected_ads_account.advertiser_id,
                    custom_audience_id: this.selected_audience.audience_id,
                    adgroup_ids: this.selected_adgroup_list.map(i => i.adgroup_id),
                    action_mode: this.apply_audience.action_mode,
                    usage_mode: this.apply_audience.usage_mode
                }
                const tiktok_account_id = this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id
                const response = await applyToAdGroups(tiktok_account_id, form)
                const {
                    code,
                    message
                } = response.data
                if (code === 0) {
                    this.$notify({
                        title: 'Thông báo',
                        message: 'Áp dụng đối tượng thành công',
                        type: 'success'
                    })
                    this.show_dialog.apply_audience = false
                } else {
                    this.$notify({
                        title: 'Lỗi',
                        message: 'Đã có lỗi xảy ra khi áp dụng đối tượng. Mã lỗi: ' + message,
                        type: 'warning'
                    })
                }
            } catch (e) {
                console.error(e)
            }

            this.loading.apply_to_adgroups = false
        },

        addAdGroupToSelectedList(adgroup) {
            if (!this.selected_adgroup_list.some(i => i.adgroup_id === adgroup.adgroup_id)) {
                this.selected_adgroup_list.push(adgroup)
            }
        },

        removeAdGroupFromSelectedList(adgroup) {
            this.selected_adgroup_list = this.selected_adgroup_list.filter(i => i.adgroup_id !== adgroup.adgroup_id)
        },

        async callGetAdGroups(campaign_id) {
            this.loading.get_adgroups = true

            this.adgroup_list = []

            const tiktok_account_id = this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id
            let page = 1
            let response = await getAdGroups(
                tiktok_account_id,
                {
                    advertiser_id: this.selected_ads_account.advertiser_id,
                    page: page,
                    page_size: 100,
                    filtering: JSON.stringify({
                        campaign_ids: [campaign_id]
                    })
                }
            )
            while (response && response.data && response.data.list && response.data.list.length) {
                this.adgroup_list.push(...response.data.list)

                page++
                response = await getAdGroups(
                    tiktok_account_id,
                    {
                        advertiser_id: this.selected_ads_account.advertiser_id,
                        page: page,
                        page_size: 100,
                        filtering: JSON.stringify({
                            campaign_ids: [campaign_id]
                        })
                    }
                )
            }

            this.loading.get_adgroups = false
        },

        async callGetCampaigns() {
            this.loading.get_campaigns = true
            this.campaign_list = []
            const tiktok_account_id = this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id
            let page = 1
            let response = await getCampaigns(tiktok_account_id, {
                advertiser_id: this.selected_ads_account.advertiser_id,
                page: page,
                page_size: 100
            })

            while (response && response.data && response.data.list && response.data.list.length) {
                this.campaign_list.push(...response.data.list)

                page++
                response = await getCampaigns(tiktok_account_id, {
                    advertiser_id: this.selected_ads_account.advertiser_id,
                    page: page,
                    page_size: 100
                })
            }

            this.loading.get_campaigns = false
        },

        async showApplyAudienceDialog(audience) {
            this.selected_audience = audience
            this.show_dialog.apply_audience = true

            this.campaign_list = []
            this.adgroup_list = []
            this.selected_adgroup_list = []
            await this.callGetCampaigns()
        },

        async confirmEnableREACHFREQUENCY(audience) {
            try {
                await this.$confirm('Cho phép sử dụng đối tượng này trong các chiến dịch Phạm vi tiếp cận và tần suất?', 'Phạm vi tiếp cận và tần suất')
            } catch (e) {
                return
            }

            await this.callUpdateAudience(audience, null, 'REACH_FREQUENCY')
        },

        async callUpdateAudience(audience, new_name = null, new_sub_type = null) {
            const form = {
                advertiser_id: this.selected_ads_account.advertiser_id,
                custom_audience_id: audience.audience_id
            }
            if (new_name) form.custom_audience_name = new_name
            if (new_sub_type) form.audience_sub_type = new_sub_type

            const response = await updateAudience(this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id, form)
            const {
                code,
                message
            } = response.data
            if (code === 0) {
                this.$notify({
                    title: 'Thông báo',
                    message: 'Cập nhật đối tượng thành công',
                    type: 'success'
                })
                await this.getAudiences()
            } else {
                this.$notify({
                    title: 'Lỗi',
                    message: 'Đã có lỗi xảy ra khi cập nhật đối tượng. Mã lỗi: ' + message,
                    type: 'warning'
                })
            }
        },

        canCreateLookalikeFromAudience(audience) {
            return audience.audience_type !== 'Lookalike Audience' && audience.is_creator
        },

        createLookalikeFromAudience(audience) {
            this.el_drawer_display_type = 'create'
            this.el_drawer_audience_type = 'lookalike'
            this.source_audience_id = audience.audience_id
            this.show_dialog.create_audience = true
        },

        async confirmShareAudiences(from_audience = null) {
            this.loading.share_audience = true
            const audience_ids = from_audience
                ? [from_audience.audience_id]
                : this.c__audience_list.filter(i => i.checked).map(i => i.audience_id)
            const form = {
                advertiser_id: this.selected_ads_account.advertiser_id,
                custom_audience_ids: audience_ids,
                shared_advertiser_ids: this.shared_advertiser_ids
            }
            await shareAudiences(this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id, form)
            this.$notify({
                title: 'Thông báo',
                message: 'Chia sẻ đối tượng thành công',
                type: 'success'
            })
            this.loading.share_audience = false
            this.show_dialog.share_audience = false
        },

        canDeleteAudiences() {
            const checked_list = this.c__audience_list.filter(i => i.checked)
            return checked_list.length
        },

        canShareAudience() {
            const checked_list = this.c__audience_list.filter(i => i.checked)
            return checked_list.length && checked_list.every(i => i.is_creator)
        },

        async confirmDeleteAudiences(from_audience = null) {
            try {
                await this.$confirm('Bạn có chắc chắn muốn xóa các đối tượng đã chọn không?', 'Chú ý')
            } catch (e) {
                return
            }

            const audience_ids = from_audience
                ? [from_audience.audience_id]
                : this.c__audience_list.filter(i => i.checked).map(i => i.audience_id)
            const form = {
                advertiser_id: this.selected_ads_account.advertiser_id,
                custom_audience_ids: audience_ids
            }
            await deleteAudiences(this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id, form)
            await this.getAudiences()
            this.$notify({
                title: 'Thông báo',
                message: 'Xoá đối tượng thành công',
                type: 'success'
            })
        },

        toggleCheckboxAll(value) {
            for (const item of this.c__audience_list) {
                item.checked = value
            }
        },

        mapAudienceType(audience) {
            if (audience.audience_type === 'Lookalike Audience') {
                return 'Đối tượng tương tự' + (audience.is_creator ? '' : ' Được chia sẻ')
            }

            return 'Đối tượng tùy chỉnh' + (audience.is_creator ? '' : ' Được chia sẻ')
        },

        mapAudienceEnum(audience) {
            if (audience.audience_type === 'Customer File Audience') {
                return 'Tệp khách hàng'
            }
            if (audience.audience_type === 'Engagement Audience') {
                return 'Sự tương tác'
            }
            if (audience.audience_type === 'App Activity Audience') {
                return 'Hoạt động trong ứng dụng'
            }
            if (audience.audience_type === 'Website Audience') {
                return 'Lưu lượng truy cập trang web'
            }
            if (audience.audience_type === 'Lead Generation Audience') {
                return 'Tạo khách hàng tiềm năng'
            }
            if (audience.audience_type === 'Rule Business Account') {
                return 'Business Account'
            }
            if (audience.audience_type === 'Rule ad shop') {
                return 'Hoạt động trong cửa hàng'
            }
            if (audience.audience_type === 'Rule Offline Events') {
                return 'Hoạt động ngoại tuyến'
            }

            return ''
        },

        generateEmitCreateId() {
            this.emit_create_id = uuid.v4()
        },

        handleChangeAdsAcc(value) {
            this.selected_ads_account = value
        },

        async getAudiences() {
            if (!this.selected_ads_account) return

            this.show_dialog.create_audience = false
            this.loading.get_data = true
            this.audience_list = []

            const tiktok_account_id = this.$store.getters.tiktokBusiness.s__selected_tiktok_business.id
            const page_size = 100
            let page = 1
            let response = await getAllAudiences(tiktok_account_id, {
                advertiser_id: this.selected_ads_account.advertiser_id,
                custom_audience_ids: [],
                page: page,
                page_size: page_size
            })
            while (response && response.data && response.data.list && response.data.list.length) {
                for (const item of response.data.list) {
                    item.checked = false
                }
                this.audience_list.push(...response.data.list)

                page++
                response = await getAllAudiences(tiktok_account_id, {
                    advertiser_id: this.selected_ads_account.advertiser_id,
                    custom_audience_ids: [],
                    page: page,
                    page_size: page_size
                })
            }
            this.loading.get_data = false
        },

        async selectAudienceType(type) {
            if (type === 'business_account') {
                return
            }

            this.el_drawer_display_type = 'create'
            this.el_drawer_audience_type = type
        }
    }
})
</script>

<style>
.active-circle {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #67c23a;
    display: inline-block;
    margin-right: 5px;
}

.inactive-circle {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #f0f0f0;
    display: inline-block;
    margin-right: 5px;
}

.audience-hover:hover .audience-option {
    display: block;
}

.audience-option .el-button--text span {
    color: #6d6e70;
}

.audience-option .el-button--text:hover span {
    color: #125570;
}

.cancel-flex-end .el-table__cell.is-sortable .cell {
    justify-content: flex-start !important;
}
</style>
